export default __webpack_public_path__ + "static/media/appStoreButton.12879e37.svg";